import { breakpoints } from "@olmokit/core/scss";
import {
  glide,
  Anchors,
  Autoplay,
  Breakpoints,
  LazyLoad,
  Controls,
  Swipe,
} from "@olmokit/core/glide";
import "@olmokit/core/glide/bullets";
import Bullspin from "utils/bullspin";
import "components/Card/Blogpost";
import "./index.scss";

/**
 * Component: Blogroll
 */
export function Blogroll(selector = ".Blogroll: .glide") {
  console.log("Blogroll mounted.");

  glide(
    selector,
    {
      autoplay: 4000,
      loop: false,
      bound: true,
      killWhen: { above: breakpoints.md },
      breakpoints: {
        [breakpoints.md]: {
          perView: 2,
        },
        [breakpoints.sm]: {
          perView: 1,
        },
      },
    },
    {
      Swipe,
      Anchors,
      Autoplay,
      Bullspin,
      Breakpoints,
      LazyLoad,
      Controls,
    }
  );  
}
